<template>
  <div v-title="$route.name">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/platform-user' }">后台用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">批量分配{{currentPlatform.name}}角色</span>
      <el-form ref="form"
               :model="form"
               :rules="formRules"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="管理员"
                          prop="admin_ids">
              <remote-select
                class="width-max"
                id-key="id"
                label-key="name"
                value-key="id"
                keyword-key="name"
                placeholder="请选择"
                v-model="form.admin_ids"
                multiple
                :query-request="getBasicPlatformUsersIndex" />
            </el-form-item>
            <el-form-item label="角色名"
                          prop="role_ids">
              <remote-select
                class="width-max"
                id-key="id"
                label-key="name"
                value-key="id"
                keyword-key="name"
                placeholder="请选择"
                v-model="form.role_ids"
                multiple
                :query-request="getRoles" />
            </el-form-item>
          </div>
        </div>
        <el-form-item>
          <el-button type="primary"
                     native-type="submit">提交表单
          </el-button>
          <el-button @click="onReload">重置</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
import { userRoleFormRules as formRules } from '../platform-user.rules.js'

export default {
  components: {},
  data () {
    return {
      roleType: this.$route.params.type,
      formRules,
      platformlist: [],
      currentPlatform: {
        name: ''
      },
      uiRole: {
        name: 'UI权限',
        host: ''
      },
      form: {
        admin_ids: [],
        role_ids: []
      },
    }
  },
  computed: {
    onUiRole () {
      return this.roleType && this.roleType === this.uiRole.name
    }
  },
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {
    this.fetchPlatformlist()
  },
  mounted () {},
  methods: {
    ...request.map([
      'getBasicPlatformUsersIndex',
    ]),
    getRoles (params) {
      const apiName = this.onUiRole ? 'getUiRolesIndex' : 'getRolesIndex'
      if (this.currentPlatform) {
        params.host = this.currentPlatform.host
      }
      return request.page(apiName, params)
    },
    onLoad () {
    },
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.onLoad()
    },
    getForm () {
      return filter.copyJson(this.form)
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.id ? this.update(this.id) : this.create()
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    create () {
      let params = this.getForm()
      const apiName = this.onUiRole ? 'batchSetAdminUIRoles' : 'batchSetAdminRoles'
      if (this.currentPlatform) {
        params.host = this.currentPlatform.host
      }
      params.admin_ids.forEach((adminId) => {
        let data = {...params, admin_id: adminId}
        delete data.admin_ids
        request.common(apiName, data).then(() => {
          this.$confirm(this.$route.name + '成功, 是否继续分配？', '提示', {type: 'success'}).then(() => {
            this.$refs.form.resetFields()
          }, () => {
            this.$router.push({ path: '/platform-user' })
          })
        })
      })
    },
    fetchPlatformlist () {
      this.platformlist = []
      return request.common('getPermissionPlatformlist', {}).then(({data}) => {
        this.platformlist.push(data.main)
        this.platformlist.push(...data.others)
        this.platformlist.push({
          name: 'UI权限',
          host: null
        })

        for (let one of this.platformlist) {
          if (one.name === this.roleType) {
            this.currentPlatform = one
          }
        }
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/platform-user/pages/PlatformUserRoleForm.vue